import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { darken } from "@material-ui/core/styles/colorManipulator";
import { Button } from "@material-ui/core";

const styles = {
    root: {
        backgroundColor: "#666666",
        marginLeft: "20px",
        height: "30px",
        padding: "0 12px 0 9px",
        color: "#fff",
        fontWeight: "600",
        fontSize: "13px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textTransform: "uppercase",
        borderRadius: 3,
        "&:hover": {
            backgroundColor: darken("#FFAA00", 0.1)
        }
    }
};

class EarnCreditButton extends React.Component {
    render() {
        return (
            <Button className={this.props.classes.root} onClick={this.props.onClick}>
                <span style={{ display: "inline-block", background: "#fa0", borderRadius: 30 }}>
                    <i className="micon" style={{ fontSize: 20, width: 22, verticalAlign: "top", position: "relative", left: ".5px" }}>attach_money</i>
                </span>
                <label>Earn Credit</label>
            </Button>
        );
    }
}

export default withStyles(styles)(EarnCreditButton);
